/** URL `?tab=` values for AMC visit overview. */
export const AmcVisitOverviewTabParam = {
  OVERVIEW: "overview",
} as const;

export type AmcVisitOverviewTabParamValue =
  (typeof AmcVisitOverviewTabParam)[keyof typeof AmcVisitOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, AmcVisitOverviewTabParamValue> = {
  "1": AmcVisitOverviewTabParam.OVERVIEW,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [AmcVisitOverviewTabParam.OVERVIEW]: "1",
};

export function amcVisitOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForAmcVisitOverviewTabId(
  tabId: string,
): AmcVisitOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidAmcVisitOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
